import React, { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router";
import TabPanel from "../../../components/TabPanel";
import {
  ordersCollection,
  useData,
} from "../../../components/firebase/DataProvider";
import { date } from "../../../utils/dateTime";
import currency from "../../../utils/currency";
import Gap from "../../../components/Gap";

//material
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import useStyle from "./style";
import DetailDialog from "./DetailDialog";
import EmptyOrder from "./EmptyOrder";
import { Button } from "@material-ui/core";

function DiBatalkanItem({ order }) {
  const classes = useStyle();
  const history = useHistory();
  const [suborders, setSuborders] = useState([]);
  useEffect(() => {
    async function fetchSuborders() {
      const suborders = await ordersCollection
        .doc(order.id)
        .collection("suborders")
        .where("order_info.owner_id", "==", order.order_info.owner_id)
        .get();

      setSuborders(
        suborders.docs.map((doc) => {
          return {
            id: doc.id,
            ...doc.data(),
          };
        })
      );
    }
    fetchSuborders();
  }, [order.id]);
  const totalBarang = useMemo(() => {
    let total = 0;
    suborders.map((x) => {
      total = total + x.products.length;
    });
    return total;
  });
  const [dialog, setDialog] = useState({
    open: false,
    orderId: {},
  });

  const handleDetail = (e) => {
    setDialog({
      open: true,
      orderId: order.id,
    });
  };

  return (
    <>
      <Paper className={classes.wrapPaper} elevation={0} onClick={handleDetail}>
        <List>
          <ListItem>
            <ListItemText
              // primary={
              //   <Typography className={classes.liquidBold}>
              //     #{order.kode_order}
              //   </Typography>
              // }
              primary={
                <Typography className={classes.liquidSecondList}>
                  {date(order.created_at?.toDate?.())}
                </Typography>
              }
            />
            <ListItemSecondaryAction>
              <div className={classes.belumBayar}>
                <Brightness1Icon
                  color="secondary"
                  style={{ fontSize: "10px", marginRight: "5" }}
                />
                <Typography className={classes.liquidSecondList}>
                  Dibatalkan
                </Typography>
              </div>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemAvatar>
              <Avatar
                variant="square"
                src={suborders?.[0]?.products?.[0]?.variant?.thumbnail?.[0]}
              />
            </ListItemAvatar>
            <ListItemText
              secondary={
                <div>
                  {/* <Typography className={classes.liquidPrimary}>
                    Jumlah Pengiriman
                  </Typography> */}
                  <Typography
                    style={{ marginBottom: "5px" }}
                    className={classes.liquidBold}
                  >
                    {suborders.length} Alamat Pengirim
                  </Typography>
                  <Typography className={classes.liquidPrimary}>
                    Total Pembayaran
                  </Typography>
                  <Typography className={classes.liquidBold}>
                    {currency(order.total_pembayaran)}
                  </Typography>
                </div>
              }
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemIcon style={{ minWidth: "40px" }}>
              <CancelOutlinedIcon />
            </ListItemIcon>
            <ListItemText
              secondary={
                <Typography className={classes.liquidSecondList}>
                  Pesananmu Dibatalkan
                </Typography>
              }
            />
            <ListItemSecondaryAction>
              <Button
                onClick={() => history.push("/")}
                color="primary"
                variant="contained"
                size="small"
              >
                <Typography
                  style={{ color: "white", fontSize: "10px", padding: "2px" }}
                  className={classes.liquidSecondList}
                >
                  Beli Lagi
                </Typography>
              </Button>
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </Paper>
      <Gap height={30} />
      <DetailDialog
        open={dialog.open}
        orderId={dialog.orderId}
        handleClose={() => {
          setDialog({
            open: false,
            orderId: {},
          });
        }}
      />{" "}
    </>
  );
}

function DiBatalkan({ value, modes }) {
  const { orders } = useData();
  const pendingOrders =
    orders
      ?.filter((order) => {
        return (
          modes === order.order_info?.location &&
          (order.status === "canceled" || order.status === "expired")
        );
      })
      .sort((a, b) => {
        const m2 = b.created_at?.toMillis?.() ?? 0;
        const m1 = a.created_at?.toMillis?.() ?? 0;

        return m2 - m1;
      }) ?? [];
  return (
    <TabPanel
      style={{ backgroundColor: "#EFF1FE" }}
      value={value}
      index="canceled"
    >
      <div>
        {pendingOrders && pendingOrders.length > 0 ? (
          pendingOrders.map((item) => {
            return <DiBatalkanItem key={item?.id} order={item} />;
          })
        ) : (
          <EmptyOrder />
        )}
      </div>
    </TabPanel>
  );
}

export default DiBatalkan;
